import React from "react";
import novice from "../../../assets/images/timelines/novoice.svg";
import intermediate from "../../../assets/images/timelines/intermediate.svg";
import proficient from "../../../assets/images/timelines/proficient.svg";
import master from "../../../assets/images/timelines/master.svg";
import elite from "../../../assets/images/timelines/elite.svg";

const stages = ["Novice", "Intermediate", "Proficient", "Master", "Elite"];

const HorizontalTimeline = ({ activeStage }) => {
  return (
    <div className="htimeline">
      <ul>
        {stages.map((stage, index) => {
          const isActive = stages.indexOf(activeStage) >= index;
          return (
            <li key={index} className={isActive ? "active" : "inactive"}>
              <p className="m-0 font-xss">{stage}</p>
              <img src={getImageForStage(stage)} alt="" />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const getImageForStage = (stage) => {
  switch (stage) {
    case "Novice":
      return novice;
    case "Intermediate":
      return intermediate;
    case "Proficient":
      return proficient;
    case "Master":
      return master;
    case "Elite":
      return elite;
    default:
      return null;
  }
};

export default HorizontalTimeline;
